import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
})
export class DeleteDialogComponent implements OnInit, AfterViewInit {
    @Input() modalMessage: string;
    @Input() modalWarningMessage: string;
    @Input() buttonText: string;
    @ViewChild('message') dialogMessage: ElementRef;
    @ViewChild('warning') warningMessage: ElementRef;
    constructor(private ngbActiveModal: NgbActiveModal) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.dialogMessage.nativeElement.innerHTML = this.modalMessage;
        if (!this.modalWarningMessage) {
            this.warningMessage.nativeElement.style.display = 'none';
        } else {
            this.warningMessage.nativeElement.style.display = 'block';
            this.warningMessage.nativeElement.innerHTML = this.modalWarningMessage;
        }
    }

    closeDialogWithResult() {
        this.ngbActiveModal.close(true);
    }

    closeDialogWithCancel() {
        this.ngbActiveModal.close(false);
    }
}
